<template>
  <section>
    <BaseFormField :label="$t('contractAddition.title')" :hint="$t('contractAddition.hint')" id="contract-addition-type">
      <BaseSelect :model-value="kind" :disabled="disabled" @update:model-value="changeKind($event)">
        <option value="none">{{ $t('common.none') }}</option>
        <option value="html">{{ $t('contractAddition.formattedText') }}</option>
        <option value="pdf">PDF</option>
      </BaseSelect>
    </BaseFormField>
    <BaseRichTextEditor v-if="kind === 'html'" :model-value="html" :label="$t('contractAddition.formattedText')" :disabled="disabled" @update:model-value="$emit('update:html', $event)" />
    <BaseFormField v-if="kind === 'pdf'" :label="$t('contractAddition.pdfFile')" id="contract-addition-file" :hint="$t('contractAddition.pdfHint')">
      <BaseInput ref="fileInput" type="file" accept="application/pdf,.pdf" :disabled="disabled" @change="chooseFile" />
      <span class="form-hint">{{ file?.name || filename }}</span>
    </BaseFormField>
    <p v-if="error" role="alert" class="text-red-400">{{ error }}</p>
    <button v-if="itemId && kind !== 'none'" type="button" class="btn ghost small" :disabled="previewing" @click="preview">
      {{ $t('contractAddition.previewSaved') }}
    </button>
    <p class="form-hint">{{ $t('contractAddition.existingDocuments') }}</p>
  </section>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import BaseRichTextEditor from '@/components/base/BaseRichTextEditor.vue'
import BaseFormField from '@/components/base/BaseFormField.vue'
import BaseInput from '@/components/base/BaseInput.vue'
import BaseSelect from '@/components/base/BaseSelect.vue'
import { previewItemContractAddition } from '@/api/api.js'

const props = defineProps({ kind: { type: String, default: 'none' }, html: { type: String, default: '' }, file: { type: File, default: null }, filename: { type: String, default: '' }, itemId: { type: [String, Number], default: null }, disabled: Boolean })
const emit = defineEmits(['update:kind', 'update:html', 'update:file'])
const { t } = useI18n()
const error = ref('')
const previewing = ref(false)

function changeKind(kind) {
  emit('update:kind', kind)
  emit('update:file', null)
  error.value = ''
}
const fileInput = ref(null)

function chooseFile(event) {
  const el = event.target
  const file = el.files?.[0]
  error.value = ''
  if (file && (file.size > 20 * 1024 * 1024 || !file.name.toLowerCase().endsWith('.pdf'))) {
    error.value = t('contractAddition.invalidPdf')
    emit('update:file', null)
    if (fileInput.value?.el) fileInput.value.el.value = ''
    else el.value = ''
    return
  }
  emit('update:file', file || null)
}
async function preview() {
  previewing.value = true
  error.value = ''
  const tab = window.open('', '_blank')
  if (tab) tab.opener = null
  try {
    const blob = await previewItemContractAddition(props.itemId)
    const url = URL.createObjectURL(blob)
    if (tab) tab.location.href = url
    else { const link = document.createElement('a'); link.href = url; link.download = 'contract-addition.pdf'; link.click() }
    setTimeout(() => URL.revokeObjectURL(url), 60000)
  } catch {
    tab?.close()
    error.value = t('contractAddition.previewFailed')
  } finally { previewing.value = false }
}
</script>
